import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CDN_BASE_URL } from "../../config";
import { priceComma } from "../../utils/priceComma";
import moment from "moment-jalaali";
import { getTiming } from "../../utils/getTiming";
import { ProductContext } from "../../context/ProductContext";

const ProductCardSpecial = ({ data, compelete }) => {
  const {
    name,
    img,
    price,
    brake,
    createdAt,
    url,
    sell,
    special_price,
    _id,
    vehicle_number,
  } = data;
  const { setselectProduct } = useContext(ProductContext);
  const now = new Date();
  const newTime = now.getTime() - new Date(createdAt).getTime();
  const hour = newTime / 86400000;

  return (
    <Link
      to={`/${url?.category?.url}/${url?.brand?.name}/${url?.name}/${vehicle_number}`}
      title={`مشخصات محصول ${name}`}
    >
      {!compelete && sell && (
        <img
          src={"/sold.png"}
          alt="sell item"
          className="absolute w-[90%] h-[90%] right-0 top-0 z-20 object-cover"
        />
      )}
      {compelete && (
        <p className="absolute top-[50%] text-center left-[50%] translate-x-[-50%] translate-y-[-50%] text-black text-[30px] px-3 z-30 font-bold w-full">
          پایان مهلت فروش ویژه
        </p>
      )}
      <div
        className={`${
          (sell || compelete) && "opacity-50"
        } w-full border-brand overflow-hidden relative`}
      >
        {img?.img_webp ? (
          <picture>
            <source type="image/webp" srcset={CDN_BASE_URL + img?.img_webp} />
            <img
              src={CDN_BASE_URL + img?.img_jpg}
              alt={name}
              title={name}
              className="w-full object-cover h-[170px]"
              loading="lazy"
            />
          </picture>
        ) : img ? (
          <img
            src={CDN_BASE_URL + img}
            alt={name}
            title={name}
            className="w-full object-cover h-[170px]"
            loading="lazy"
          />
        ) : (
          <img
            loading="lazy"
            src={"/no-image.jpg"}
            title={name}
            alt={name}
            className="w-full object-cover h-[170px]"
          />
        )}

        <div className="w-full p-3">
          <span className="flex w-full justify-between items-center pb-1">
            <h3 className="text-[16px] 2xl:text-[20px] font-[600]">{name} </h3>
            <p className="text-[14px] 2xl:text-[16px]">{getTiming(hour)}</p>
          </span>
          <span className="flex w-full justify-between items-center pt-1">
            <p>{brake}</p>
            <h3
              className={`${
                special_price && "price-line"
              } text-[20px] text-[#FFA800] font-[600] relative`}
            >
              {priceComma(price * 1000000000, 2)}
              {special_price && (
                <>
                  <br />
                  {priceComma(special_price * 1000000000, 2)}
                </>
              )}
            </h3>
          </span>
        </div>
      </div>
    </Link>
  );
};

export default ProductCardSpecial;
